import horizontalScroll from '../../../src/js/modules/horizontal-scroll';

const clear = elements => {
  const menuElements = elements.querySelectorAll('[js-data-tab]');
  Array.prototype.forEach.call(menuElements, el => {
    el.classList.remove('active');
    const id = el.getAttribute('js-data-tab');
    const contents = elements.querySelectorAll(`[js-tab-content="${id}"]`);

    Array.prototype.forEach.call(contents, content => {
      content.classList.remove('active');
    });
  });
};

const getActiveMenuEle = (eles) => {
  for (var entry of eles.entries()) {
    if (entry[1].classList.contains('active')) {
      return  entry[0];
    }
  }
}


const bindAll = () => {
  const tabs = document.querySelectorAll('[js-tabs]');
  Array.prototype.forEach.call(tabs, elements => {
    const menuElements = elements.querySelectorAll('[js-data-tab]');
    const prevEle = elements.querySelector('.js-tabs-prev');
    const nextEle = elements.querySelector('.js-tabs-next');
    const ScrollableNav = horizontalScroll(elements.querySelector('.js-tabs-nav-scrollable-area'));

    const updateNexPrevButtons = (currentKey, elements) => {
      const key = parseInt(currentKey);

      if(key === 0) {
        prevEle.classList.add('disabled');
        nextEle.classList.remove('disabled');
        return;
      } else if(key === elements.length -1) {
        nextEle.classList.add('disabled');
        prevEle.classList.remove('disabled');
      } else {
        nextEle.classList.remove('disabled');
        prevEle.classList.remove('disabled');
      }
    }

    const change = e => {
      clear(elements);
      e.target.classList.add('active');
      const id = e.currentTarget.getAttribute('js-data-tab');
      const contents = elements.querySelectorAll(`[js-tab-content="${id}"]`);

      updateNexPrevButtons(e.target.dataset.key, menuElements);

      ScrollableNav.scrollTo(e.currentTarget);

      Array.prototype.forEach.call(contents, el => {
        el.classList.add('active');
      });
    };

    Array.prototype.forEach.call(menuElements, el => {
      el.addEventListener('click', change, false);
    });

    prevEle.addEventListener('click', () => {
      const prev = menuElements.item(getActiveMenuEle(menuElements) - 1);
      if (prev) {prev.click();}
    });

    nextEle.addEventListener('click', () => {
      const next = menuElements.item(getActiveMenuEle(menuElements) + 1);
      if (next) {next.click();}
    });

    updateNexPrevButtons(0, menuElements);
  });
};

const tabs = async () => {
  bindAll();
};

export default tabs;
